export const IN_ROOM_ANNOUNCEMENT_USER_JOINED =
  "INROOMANNOUNCEMENT::IN_ROOM_ANNOUNCEMENT_USER_JOINED";
export const IN_ROOM_ANNOUNCEMENT_USER_LEFT =
  "INROOMANNOUNCEMENT::IN_ROOM_ANNOUNCEMENT_USER_LEFT";
export const IN_ROOM_ANNOUNCEMENT_ICON_CLICKED =
  "INROOMANNOUNCEMENT::IN_ROOM_ANNOUNCEMENT_ICON_CLICKED";
